import React from "react";

import type { IContextType } from ".";

export const PopoverContext = React.createContext<IContextType>(null);
